import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';
export const CategoryCard = ({
  id,
  icon,
  text,
  onClick,
  selected,
  iconName,
  iconSubFolder,
  preferenceType = 'global',
}) => {
  if (preferenceType == 'global') {
    return (
      <div
        id={`categorycard-${preferenceType}-${id}-wrapper`}
        style={{
          background: selected ? '#F7A246' : '#C2C2C2',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        className="flex"
        onClick={(e) => {
          onClick(text);
        }}
      >
        <div id={`categorycard-${preferenceType}-${icon}-icon`} style={{ margin: '0.8rem' }}>{icon}</div>
        <div
          id={`categorycard-${preferenceType}-${text}-content`}
          style={{ fontSize: '20px', fontWeight: 700, lineHeight: '2rem', color: '#FFF' }}
        >
          {text}
        </div>
      </div>
    );
  } else {
    return (
      <div
        id={`categorycard-${preferenceType}-${id}-wrapper`}
        style={{
          background: '#FFFFFF',
          alignItems: 'center',
          cursor: 'pointer',
          height: '45px',
          borderRight: selected ? '3px solid #006AF5' : '0px solid #006AF5',
        }}
        className="flex"
        onClick={(e) => {
          onClick(text);
        }}
      >
        <div
          id={`categorycard-${preferenceType}-${iconName}-icon`} 
          style={{ margin: '0.8rem', color: '#006AF5' }}>
          <RMSvgIcon
            id={`categorycard-${preferenceType}-${iconName}-svg-icon`} 
            name={iconName}
            subfolder={iconSubFolder}
            width="24px"
            height="24px"
            fill={selected ? '#006AF5' : '#737373'}
          />
        </div>
        <div
          id={`categorycard-${preferenceType}-${text}-content`}
          style={{
            fontSize: '17px',
            fontWeight: 500,
            lineHeight: '2rem',
            color: selected ? '#006AF5' : '#737373',
          }}
        >
          {text}
        </div>
      </div>
    );
  }
};
